import lang from '@/lang'
import { MultiSelectItemObj } from '@/components/multi-select/types'
import { MultiSelectTypes } from '@/components/multi-select/constants'

export const getMultiSelectItemInfoLabel = (item: MultiSelectItemObj): string => {
  const { id, multiSelectType, number, tenantName } = item

  switch (multiSelectType) {
    case MultiSelectTypes.Customer:
    case MultiSelectTypes.CustomerContact:
      return `${lang.multiSelect.types.label.customer}-${lang.generics.number.short}: ${number}`
    case MultiSelectTypes.Supplier:
    case MultiSelectTypes.SupplierContact:
      return `${lang.multiSelect.types.label.supplier}-${lang.generics.number.short}: ${number}`
    case MultiSelectTypes.Client:
      return `${lang.generics.client}: ${tenantName || id}`
    case MultiSelectTypes.External:
      return lang.multiSelect.types.label.external
    case MultiSelectTypes.User:
      return lang.multiSelect.types.label.user
  }
}
